import React from 'react';
import {Bar, BarChart, CartesianGrid, LabelList, Legend, XAxis, YAxis} from 'recharts';
import DatePicker from 'react-datepicker';
import Loader from 'react-loader-spinner';
import moment from 'moment';
import axios from './../../constants/axios';
import './Dashboard.less';

class Dashboard extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         busy: true,
         date: moment(),
         saleOverview: {},
         saleHourlyDetails: {},
         purchaseOverview: {},
         authorizedOverview: {},
         expenseOverview: {},
         expenseTypes: {},
         cashFlows: {},
         contactDue: 0,
      };
   }

   componentDidMount() {
      this.getDetails(this.state.date);
   }

   getDetails = (date) => {
      this.setState({
         busy: true,
      });
      return axios.get('dashboard', {
         params: {
            date: date.format('YYYY-MM-DD')
         }
      })
         .then((res) => {
            this.setState({
               busy: false,
               date: date,
               saleOverview: res.data.saleOverview,
               saleHourlyDetails: res.data.saleHourlyDetails,
               purchaseOverview: res.data.purchaseOverview,
               authorizedOverview: res.data.authorizedOverview,
               expenseOverview: res.data.expenseOverview,
               expenseTypes: res.data.expenseTypes,
               cashFlows: res.data.cashFlows,
               contactDue: res.data.due,
            });
         });
   };

   handleDateChange = (date) => {
      this.getDetails(date);
   };

   render() {
      const {saleOverview, saleHourlyDetails, purchaseOverview, authorizedOverview, expenseOverview, expenseTypes, cashFlows, contactDue} = this.state;
      if (this.state.busy === true) return (
         <div className="busy_spinner"><Loader type="Puff" color="#00BFFF"/></div>);
      return (
         <div>
            <div className="Dashboard__overview_container">
               <div>
                  <DatePicker
                     dateFormat="DD-MM-YYYY"
                     selected={this.state.date}
                     placeholderText="Select Date"
                     onChange={this.handleDateChange}/>
               </div>
               <h1>Daily Overview {this.state.date.format('YYYY-MM-DD')}</h1>
               <hr/>
               <h2>Sale Overview</h2>
               <div className="charts">
                  <BarChart width={250} height={250} data={saleOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="amount"/>
                     <Bar dataKey="amount" fill="#8884d8">
                        <LabelList dataKey="amount" position="center" angle="90"/>
                     </Bar>
                     <Legend payload={saleOverview.legendAmount}/>
                  </BarChart>
                  <BarChart width={400} height={250} data={saleHourlyDetails.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="hour"/>
                     <YAxis dataKey="amount"/>
                     <Bar dataKey="amount" fill="#8884d8">
                        <LabelList dataKey="amount" position="center" angle="90"/>
                     </Bar>
                     <Legend payload={saleHourlyDetails.legendAmount}/>
                  </BarChart>
                  <BarChart width={250} height={250} data={saleOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="number_of_invoice"/>
                     <Bar label dataKey="number_of_invoice" fill="#82ca9d"/>
                     <Legend payload={saleOverview.legendCount}/>
                  </BarChart>
               </div>
            </div>
            <div className="Dashboard__overview_container">
               <h2>Purchase Overview</h2>
               <div className="charts">
                  <BarChart width={300} height={300} data={purchaseOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="amount"/>
                     <Bar label dataKey="amount" fill="#8884d8"/>
                     <Legend payload={purchaseOverview.legendAmount}/>
                  </BarChart>
                  <BarChart width={300} height={300} data={purchaseOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="number_of_invoice"/>
                     <Bar label dataKey="number_of_invoice" fill="#82ca9d"/>
                     <Legend payload={purchaseOverview.legendCount}/>
                  </BarChart>
                  <BarChart width={300} height={300} data={authorizedOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="number_of_invoice"/>
                     <Bar label dataKey="number_of_invoice" fill="#DD5A43"/>
                     <Legend payload={authorizedOverview.legendCount}/>
                  </BarChart>
               </div>
            </div>
            <div className="Dashboard__overview_container">
               <h2>Expense Overview</h2>
               <div className="charts">
                  <BarChart width={300} height={300} data={expenseOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="amount"/>
                     <Bar label dataKey="amount" fill="#8884d8"/>
                     <Legend payload={expenseOverview.legendAmount}/>
                  </BarChart>
                  <BarChart width={300} height={300} data={expenseOverview.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="number_of_invoice"/>
                     <Bar label dataKey="number_of_invoice" fill="#82ca9d"/>
                     <Legend payload={expenseOverview.legendCount}/>
                  </BarChart>
                  <BarChart width={300} height={300} data={expenseTypes.invoices}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="amount"/>
                     <Bar label dataKey="amount" fill="#82ca9d"/>
                     <Legend payload={expenseOverview.legendAmount}/>
                  </BarChart>
               </div>
            </div>
            <div className="Dashboard__overview_container">
               <h2>Others</h2>
               <div className="charts">
                  <BarChart width={300} height={300} data={cashFlows.charts}>
                     <CartesianGrid strokeDasharray="3 3"/>
                     <XAxis interval={0} tick={{fontSize: 8}} dataKey="name"/>
                     <YAxis dataKey="value"/>
                     <Bar label dataKey="value" fill="#8884d8"/>
                     <Legend payload={cashFlows.legend}/>
                  </BarChart>
               </div>
            </div>
            <div >
               <h2>Extra Info</h2>
               <div>Today's Due Sales: {contactDue}</div>
            </div>
         </div>
      );
   }
}

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/Dashboard.js
 **/